import * as React from "react";
import ReactHtmlParser from 'react-html-parser';

export interface AlertProps {
  formFieldDefinition: any;
}

export const Alert = (props: AlertProps) => {

  let alertclass = (props.formFieldDefinition.alertClass || "").toLowerCase();
  let label = "<p>" + props.formFieldDefinition.label + "</p>";

  if (props.formFieldDefinition.alert !== undefined && props.formFieldDefinition.alert !== "") {
    label = props.formFieldDefinition.alert;
  }

  let labelHtml = ReactHtmlParser(label);

  return <div className={"alert alert-" + alertclass}>
    {labelHtml}
  </div>;
};